(function (BraintreeModule, app) {
    
        app.Braintree = new BraintreeModule({
            stylesOptions: {
                'input': { 'font-size': '12px', 'color': '#333333', 'font-family': 'Verdana', 'font-weight': 'normal' },
                'input:focus:-moz-placeholder': { 'color': 'transparent' },
                'input:focus::-moz-placeholder': { 'color': 'transparent' },
                'input:focus::-webkit-input-placeholder': { 'color': 'transparent' },
                'input:focus:-ms-input-placeholder': { 'color': 'transparent' }
            },
            fieldsOptions: {
                number: { selector: '#card-number', placeholder: '1234 1234 1234 1234' },
                cvv: { selector: '#cvv', placeholder: '100' },
                expirationDate: { selector: '#expiration-date', placeholder: '01 / 19' }
            },
            fieldErrorClass: 'braintree-hosted-fields-invalid',
            currencyIso: GlobalSettings.Currency
        });

})(BraintreeModule, app);